import { useQueryClient } from '@tanstack/react-query'

export const useGetQueryDataRq = key => {
  const queryClient = useQueryClient()

  return queryClient.getQueryData(key)
}
